<!--
  - Copyright (c) 2022. Venus GmbH <info@venus.bayern> - All Rights Reserved
  - Unauthorized copying of this file, via any medium is strictly prohibited Proprietary and confidential
  - Written by Dominik Lippl <dl@venus.bayern>
  -->

<template>
  <loading-component>
    <template #content>
      <div class="flex flex-col gap-4 xl:mx-60">
        <div class="self-start">
          <back-component></back-component>
        </div>

        <upsert-user-component v-model="user" @save="save" />
      </div>
    </template>
  </loading-component>
</template>

<script>
import { mapStores } from "pinia";
import { useUsersStore } from "@/stores/users";
import { useApplicationStore } from "@/stores/application";
import LoadingComponent from "@/components/LoadingComponent";
import Notifications from "@auth/vue-share/utility/notifications";
import BackComponent from "@/components/BackComponent";
import UpsertUserComponent from "@/components/users/UpsertUserComponent";
import logger from "@auth/vue-share/utility/logger";

export default {
  name: "EditUserView",
  components: { UpsertUserComponent, BackComponent, LoadingComponent },
  props: ["id"],
  data() {
    return {
      user: undefined
    };
  },
  async created() {
    this.applicationStore.setLoading(true);
    this.usersStore.getUser(this.id).then((response) => {
      this.user = response.data;
      this.applicationStore.setLoading(false);
    });
  },
  computed: {
    ...mapStores(useUsersStore, useApplicationStore)
  },
  methods: {
    save(user) {
      this.usersStore.updateUser(user).then(() => {
        Notifications.success("Benutzer erfolgreich gespeichert");
      }).catch((error) => {
        Notifications.success("Benutzer konnte nicht gespeichert werden");
        logger.error("[USER]", error);
      });
    }
  }
};
</script>

<style scoped>

</style>